import FundAssetsTable from "domains/liquidity/components/FundAssetsTable/FundAssetsTable";

export default FundAssetsTable;
